import { useEffect, useState } from "react"
import Content from "../../../components/Content"
import { useAppDispatch, useAppSelector } from "../../../store/store"
import PlayerInterface from "../../../interfaces/Player.interface"
import { updatePlayerData } from "../../../services/players.services"
import { setPlayer } from "../../../store/features/playerSlice"
import { toast } from "react-toastify"
import Select, { ActionMeta, SingleValue } from 'react-select';
import InputText from "../../../components/InputText"
import Button from "../../../components/Button"
import countryList from "../../../data/countryList"

const genderDictionary: Record<string, { value: string, label: string }> = {
    "male": { value: "male", label: "Hombre" },
    "female": { value: "female", label: "Mujer" },
}

export interface LabelOption {
    label: string
    value: string
}

const PlayerEditPage = () => {
    const token = useAppSelector(state => state.token)
    const player = useAppSelector(state => state.player)
    const dispatch = useAppDispatch()

    const [data, setData] = useState<PlayerInterface>({
        email: player.email,
        description: player.description,
        country: player.country,
        gender: player.gender,
    })

    const [currentCountry, setCurrentCountry] = useState<LabelOption | undefined>()
    const [currentGender, setCurrentGender] = useState<LabelOption | undefined>()

    const [requesting, setRequesting] = useState<boolean>(false)

    const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
        event.preventDefault()
        setRequesting(true)

        updatePlayerData({ data, token: token || "" })
            .then((res) => dispatch(setPlayer(res.data.payload.player)))
            .catch(() => toast.error("Ha ocurrido un error"))
            .finally(() => setRequesting(false))
    }
    const handleInputChange: React.ChangeEventHandler<HTMLInputElement> = (event) => setData({ ...data, [event.target.name]: event.target.value })

    const setSelectedCountry: ((newValue: SingleValue<{
        value: string;
        label: string;
    }>, actionMeta: ActionMeta<{
        value: string;
        label: string;
    }>) => void) = (value) => {
        setData({ ...data, country: value?.value })
        setCurrentCountry(value as LabelOption)
    }

    const setSelectedGender: ((newValue: SingleValue<{
        value: string;
        label: string;
    }>, actionMeta: ActionMeta<{
        value: string;
        label: string;
    }>) => void) = (value) => {
        setData({ ...data, gender: value?.value as string })
        setCurrentGender(genderDictionary[value?.value as string])
    }

  

    useEffect(() => {
        if (player.country) {
            setCurrentCountry({ label: player.country.split(',')[1], value: player.country as string })
        }
        if (player.gender) setCurrentGender(genderDictionary[player.gender as string])
    }, [player])
    return (
        <div className="flex flex-col">
        <Content className="flex justify-center">
            <form className="flex flex-col gap-5 max-w-[420px] w-full" onSubmit={handleSubmit}>
                <InputText type="text" name="name" placeholder="Nickname" value={player?.name as string} readOnly />
                <InputText type="email" name="email" placeholder="Correo electrónico" value={data.email as string} onChange={handleInputChange} />
                <InputText type="text" name="description" placeholder="Descripción" value={data.description as string} onChange={handleInputChange} />
                <Select
                    defaultValue={currentCountry}
                    value={currentCountry}
                    styles={{
                        control: (baseStyles) => ({
                            ...baseStyles,
                            height: 45
                        })
                    }}
                    onChange={setSelectedCountry}
                    options={countryList.map(data => {
                        return { value: `${data.code},${data.country}`, label: data.country }
                    })}
                    placeholder="Selecciona tu país"
                />
                <Select
                    defaultValue={currentGender}
                    value={currentGender}
                    styles={{
                        control: (baseStyles) => ({
                            ...baseStyles,
                            height: 45
                        })
                    }}
                    onChange={setSelectedGender}
                    options={[
                        { label: "Hombre", value: "male" },
                        { label: "Mujer", value: "female" },
                    ]}
                    placeholder="Género"
                />
                <Button spinner={requesting} disabled={requesting}>Actualizar</Button>
            </form>
        </Content>
    </div>
    )
}

export default PlayerEditPage